import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const TbGreaterOrEqualsToIcon = () => {
    return (
        <SvgIcon>
            <polygon points="3.89 7.1 4.93 6.06 9.84 10.96 9.84 10.96 10.89 12 4.97 17.94 3.93 16.91 8.8 12.01 3.89 7.1" />
            <path d="M20,9.74H11v1.47h9Zm-8.92,4.41h9V12.67h-9Z" />
        </SvgIcon>
    );
};
